import React, { useState } from 'react';
import { Button, Nav, Navbar, Container } from 'react-bootstrap';

import { Networks } from 'impermax-sdk';
import { useWallet } from 'use-wallet';

import { HomeRoute, BountyRoute, DocsRoute, LiteRoute } from '../../Routing';
import { useNetworkName, useNetworkCode, useNetworkHumanReadableName } from '../../hooks/useNetwork';
import { useThisAccountUrl } from '../../hooks/useUrlGenerator';
import { switchChainDataMap } from '../../utils/connections';
import NetworkSelectorModal from '../InteractionModal/NetworkSelectorModal';
import NavigationBarLink from '../NavigationBarLink';
import { ClaimAirdrop } from './ClaimAirdrop';
import { ConnectedWalletButtonComponent } from './ConnectedWalletButtonComponent';
import './index.scss';

interface ViewProps {
    children: React.ReactNode;
}

/**
 * Creates a view component that wraps application page content.
 * @param param0 ViewProps
 */
export default function View({ children }: ViewProps) {
    const { account, connect, status, error } = useWallet();

    const wrongNetwork = status == 'error' && error && error.toString().indexOf('ChainUnsupportedError') >= 0;
    const connected = status == 'connected';

    const networkName = useNetworkName();
    const networkCode = (useNetworkCode()).replace(".", "");
    const networkHumanReadableName = useNetworkHumanReadableName();

    const accountUrl = useThisAccountUrl();

    const [showNetworkSelectorModal, toggleNetworkSelectorModal] = useState(false);

    const onConnect = () => {
        if (wrongNetwork) {
            const addNetworkData = switchChainDataMap[networkName as Networks];
            const switchChainData = {
                chainId: addNetworkData.chainId,
            };
            window.ethereum
                .request({
                    method: 'wallet_switchEthereumChain',
                    params: [switchChainData],
                })
                .catch(() => {
                    window.ethereum
                        .request({
                            method: 'wallet_addEthereumChain',
                            params: [addNetworkData],
                        })
                        .catch()
                        .then(() => {
                            connect('injected');
                        });
                })
                .then(() => {
                    connect('injected');
                });
        } else {
            try {
                localStorage.removeItem('signOut');
                connect('injected');
            } catch (error) {
                console.log(error);
            }
        }
    };

    return (
        <div className="view">
            <Navbar>
                <Container>
                    <Navbar.Brand>
                        <a href="https://impermax.finance/" target="_blank">
                            <img className="impermax-brand" src="../../assets/impermax.png" />
                        </a>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Nav className="mr-auto">
                        <NavigationBarLink appRoute={HomeRoute} />
                        {accountUrl && <NavigationBarLink appRoute={{ value: 'Dashboard', to: accountUrl }} />}
                        <NavigationBarLink appRoute={LiteRoute} target="_blank" />
                        {accountUrl && <NavigationBarLink appRoute={BountyRoute} />}
                        <NavigationBarLink appRoute={DocsRoute} target="_blank" />
                        {/*<NavigationBarLink appRoute={BridgeRoute} target="_blank" />*/}
                        {/*<NavigationBarLink appRoute={UserGuideRoute} target="_blank" />*/}
                        {/*<NavigationBarLink appRoute={RisksRoute} />*/}
                        {/*<NavigationBarLink appRoute={ClaimRoute} />*/}
                        {/*<NavigationBarLink appRoute={CreateNewPairRoute} />*/}
                    </Nav>
                    <ClaimAirdrop />
                    <div className={'network-selected ' + networkCode} onClick={() => toggleNetworkSelectorModal(true)}>
                        <img className="network-logo" src={'../../assets/networks-white/' + networkCode + '.png'} />{' '}
                        {networkHumanReadableName}
                    </div>
                    {account ? (
                        <ConnectedWalletButtonComponent account={account} />
                    ) : (
                        <Button className="wallet-connector nav-button-green" onClick={onConnect}>
                            Connect Wallet
                        </Button>
                    )}
                </Container>
            </Navbar>
            {!connected && wrongNetwork && (
                <div className="wrong-network">
                    <div className="container">
                        You're connected to the wrong network. Please connect to the supported network:{' '}
                        {networkHumanReadableName}
                    </div>
                </div>
            )}
            {!connected && !wrongNetwork && (
                <div className="not-connected">
                    <div className="container">Please connect with Metamask or another web3 provider</div>
                </div>
            )}
            {children}
            <div className="footer container">
                <a href="https://impermax.finance/" target="_blank">
                    Website
                </a>
                <a href="https://twitter.com/ImpermaxFinance" target="_blank">
                    Twitter
                </a>
                <a href="https://t.me/ImpermaxFinance" target="_blank">
                    Telegram
                </a>
                <a href="https://discord.gg/6usxc3MJ56" target="_blank">
                    Discord
                </a>
                <a href="https://impermax.medium.com/" target="_blank">
                    Medium
                </a>
                <a href="https://www.reddit.com/r/ImpermaxFinance/" target="_blank">
                    Reddit
                </a>
                <a href="https://github.com/Impermax-Finance" target="_blank">
                    Github
                </a>
            </div>
            <NetworkSelectorModal show={showNetworkSelectorModal} toggleShow={toggleNetworkSelectorModal} />
        </div>
    );
}
